export default "__VITE_ASSET__cd8e4540__"